import { polyfill } from 'es6-promise'
polyfill()

import Vue from 'vue/dist/vue.esm'
import Vuex from 'vuex/dist/vuex.esm'
import { storeFormFeedback } from './shared/_store-form-feedback.js'
import { storeMap } from './shared/_store-map.js'
import { storeModal } from './shared/_store-modal.js'
import { storeToggle } from './shared/_store-toggle.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    form: storeFormFeedback,
    map: storeMap,
    modal: storeModal,
    toggle: storeToggle,
  }
})
